(function () {
  const STORAGE_KEY = 'theme:wishlist';

  const Wishlist = {
    getItems() {
      try {
        const items = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
        return Array.isArray(items) ? items : [];
      } catch (e) {
        return [];
      }
    },

    saveItems(items) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
      document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { items } }));
    },

    has(productId) {
      const id = String(productId);
      return this.getItems().some((item) => String(item.id) === id);
    },

    toggle(product) {
      const id = String(product.id);
      const items = this.getItems();
      const index = items.findIndex((item) => String(item.id) === id);

      if (index >= 0) {
        items.splice(index, 1);
      } else {
        items.push({
          id,
          handle: product.handle
        });
      }

      this.saveItems(items);
      return index < 0;
    },

    remove(productId, silent) {
      const id = String(productId);
      const items = this.getItems().filter((item) => String(item.id) !== id);
      if (silent) {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
        return;
      }
      this.saveItems(items);
    },

    removeMany(productIds) {
      const ids = new Set(productIds.map(String));
      const items = this.getItems().filter((item) => !ids.has(String(item.id)));
      this.saveItems(items);
    }
  };

  window.theme = window.theme || {};
  window.theme.wishlist = Wishlist;

  class WishlistButton extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.wishlist-button');
      if (!this.button) return;

      this.productId = this.dataset.productId;
      this.productHandle = this.dataset.productHandle;

      this.onClick = this.onClick.bind(this);
      this.onWishlistUpdated = this.onWishlistUpdated.bind(this);

      this.button.addEventListener('click', this.onClick);
      document.addEventListener('wishlist:updated', this.onWishlistUpdated);

      this.updateState();
    }

    disconnectedCallback() {
      if (this.button) {
        this.button.removeEventListener('click', this.onClick);
      }
      document.removeEventListener('wishlist:updated', this.onWishlistUpdated);
    }

    onClick(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      Wishlist.toggle({
        id: this.productId,
        handle: this.productHandle
      });
    }

    onWishlistUpdated() {
      this.updateState();
    }

    updateState() {
      const isWishlisted = Wishlist.has(this.productId);
      this.classList.toggle('is-wishlisted', isWishlisted);
      this.button.classList.toggle('is-wishlisted', isWishlisted);
      this.button.setAttribute('aria-pressed', isWishlisted ? 'true' : 'false');

      const label = isWishlisted
        ? (window.theme.strings.wishlistRemove || 'Remove from wishlist')
        : (window.theme.strings.wishlistAdd || 'Add to wishlist');
      this.button.setAttribute('aria-label', label);
    }
  }

  if (!customElements.get('wishlist-button')) {
    customElements.define('wishlist-button', WishlistButton);
  }

  function updateHeaderWishlistLink() {
    const hasItems = Wishlist.getItems().length > 0;
    document.querySelectorAll('.header-wishlist-link').forEach((link) => {
      link.classList.toggle('has-items', hasItems);
    });
  }

  async function renderWishlistPage() {
    const page = document.querySelector('[data-wishlist-page]');
    if (!page) return;

    const grid = page.querySelector('[data-wishlist-grid]');
    const empty = page.querySelector('[data-wishlist-empty]');
    const loading = page.querySelector('[data-wishlist-loading]');
    if (!grid || !empty) return;

    const items = Wishlist.getItems();
    const sectionId = page.dataset.wishlistCardSection || 'wishlist-card';
    const root = window.theme.routes.base.replace(/\/$/, '');

    if (loading) loading.hidden = false;
    grid.innerHTML = '';

    if (items.length === 0) {
      empty.hidden = false;
      if (loading) loading.hidden = true;
      return;
    }

    empty.hidden = true;

    const staleIds = [];

    const fragments = await Promise.all(items.map(async (item) => {
      try {
        const response = await fetch(`${root}/products/${encodeURIComponent(item.handle)}?section_id=${sectionId}`);
        if (!response.ok) {
          staleIds.push(item.id);
          return null;
        }
        const html = await response.text();
        const template = document.createElement('template');
        template.innerHTML = html.trim();
        return template.content.firstElementChild;
      } catch (e) {
        return null;
      }
    }));

    if (staleIds.length) {
      Wishlist.removeMany(staleIds);
    }

    fragments.filter(Boolean).forEach((node) => grid.appendChild(node));

    if (loading) loading.hidden = true;

    const validCount = fragments.filter(Boolean).length;
    if (validCount === 0) {
      empty.hidden = false;
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    updateHeaderWishlistLink();
    renderWishlistPage();
  });

  document.addEventListener('wishlist:updated', () => {
    updateHeaderWishlistLink();
    if (document.querySelector('[data-wishlist-page]')) {
      renderWishlistPage();
    }
  });

  document.addEventListener('shopify:section:load', () => {
    updateHeaderWishlistLink();
    renderWishlistPage();
  });
})();
